module.exports = __webpack_public_path__ + "img/椭圆形(1).a85f88e2.png";